const PENDING_REGISTRATION_EMAIL_KEY = "terramatrix.registration.pendingEmail";
const MAX_PENDING_REGISTRATION_EMAIL_LENGTH = 254;
const PENDING_REGISTRATION_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const getSessionStorage = (): Storage | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const normalizePendingRegistrationEmail = (email: string): string => {
  const trimmedEmail = email.trim();
  if (
    trimmedEmail.length === 0 ||
    trimmedEmail.length > MAX_PENDING_REGISTRATION_EMAIL_LENGTH ||
    !PENDING_REGISTRATION_EMAIL_PATTERN.test(trimmedEmail)
  ) {
    return "";
  }

  return trimmedEmail;
};

export const savePendingRegistrationEmail = (email: string): void => {
  const normalizedEmail = normalizePendingRegistrationEmail(email);
  if (!normalizedEmail) {
    return;
  }

  try {
    getSessionStorage()?.setItem(
      PENDING_REGISTRATION_EMAIL_KEY,
      normalizedEmail,
    );
  } catch {
    return;
  }
};

export const readPendingRegistrationEmail = (): string => {
  try {
    return normalizePendingRegistrationEmail(
      getSessionStorage()?.getItem(PENDING_REGISTRATION_EMAIL_KEY) ?? "",
    );
  } catch {
    return "";
  }
};

export const clearPendingRegistrationEmail = (): void => {
  try {
    getSessionStorage()?.removeItem(PENDING_REGISTRATION_EMAIL_KEY);
  } catch {
    return;
  }
};
